<template>
  <div>
    <h1 class="text-center">
      {{ $t('welcome') }}
    </h1>
    <p class="lead text-center">
      <i18n path="portal.signInInstructions">
        <router-link :to="{name: 'enrollment'}">
          {{ $t('clickHere') }}
        </router-link>
      </i18n>
    </p>
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h3 class="mb-0">
              {{ $t('resetYourPassword') }}
            </h3>
          </div>
          <div class="card-body">
            <b-alert v-model="showError" variant="danger" dismissible>
              <p v-for="(error, i) in globalErrors" :key="i">
                {{ error }}
              </p>
            </b-alert>
            <p>
              {{ $t('resetPassword.requestInstructions1', {study: study.portal_name || study.name}) }}
            </p>
            <p>
              {{ $t('resetPassword.requestInstructions2', {study: study.portal_name || study.name}) }}
            </p>
            <form @submit.prevent="onSubmit" v-if="!showConfirmation">
              <div class="form-group" :class="{'has-errors': errors.has('account_identifier')}">
                <label for="account_identifier">{{ $t('portal.usernameOrEmail') }}</label>
                <input
                  id="account_identifier"
                  v-model="account_identifier"
                  v-validate="'required'"
                  type="text"
                  name="account_identifier"
                  class="form-control"
                >
                <ul v-if="errors.has('account_identifier')" class="error-list">
                  <li>{{ errors.first('account_identifier') }}</li>
                </ul>
              </div>

              <input
                type="submit"
                class="btn btn-primary"
                :value="$t('requestReset')"
                :disabled="showConfirmation"
              >
              <router-link :to="{name: 'login'}" class="btn btn-link">
                {{ $t('cancel') }}
              </router-link>
            </form>
            <b-alert v-model="showConfirmation" variant="success">
              {{ $t('resetPassword.requestConfirmation', {study: study.portal_name || study.name}) }}
            </b-alert>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { BAlert } from "bootstrap-vue";

  export default {
    components: {
      BAlert,
    },
    props: {
      'studyId': {
        type: Number,
        required: true,
      },
      'study': {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        account_identifier: this.$route.query.identifier || '',
        showError: false,
        globalErrors: [],
        showConfirmation: false
      }
    },
    computed: {},
    methods: {
      async onSubmit() {
        try {
          let res = await this.$validator.validate();
          if (!res) {
            return;
          }
          this.$store.commit('SET_LOADING', true);
          await this.$store.dispatch('RESET_REQUEST', {
            account_identifier: this.account_identifier,
            study_id: this.studyId
          });

          this.showConfirmation = true;
          this.$store.commit('SET_LOADING', false);
        } catch (err) {
          if (err.response && err.response.body) {
            if (err.response.body.errors && err.response.body.errors.length) {
              this.globalErrors = err.response.body.errors;
              this.showError = true;
            }
          } else {
            this.globalErrors = ['Something went wrong. Please try again later.'];
            this.showError = true;
          }
          this.$store.commit('SET_LOADING', false);
        }
      }
    }
  }
</script>
